<template>
  <div class="chart-container">
    <h5 v-if="title" class="chart-title">{{ title }}</h5>
    <div v-if="loading" class="d-flex justify-content-center align-items-center h-100">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Chargement...</span>
      </div>
    </div>
    <div v-else class="gauge-wrapper">
      <Doughnut
        :chart-data="gaugeChartData"
        :chart-options="gaugeChartOptions"
      />
      <div class="gauge-center">
        <div class="gauge-value">{{ value }}%</div>
        <div class="gauge-label" v-if="centerLabel">{{ centerLabel }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js'

ChartJS.register(ArcElement, Tooltip)

export default {
  name: 'GaugeChart',
  components: { Doughnut },
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      required: true,
      validator: value => value >= 0 && value <= 100
    },
    centerLabel: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    thresholds: {
      type: Object,
      default: () => ({
        danger: 33,
        warning: 66,
        success: 100
      })
    }
  },
  computed: {
    gaugeChartData() {
      const value = this.value;
      const remainder = 100 - value;
      
      return {
        datasets: [
          {
            data: [value, remainder],
            backgroundColor: [this.getColorForValue(value), '#e9ecef'],
            borderWidth: 0,
            circumference: 180,
            rotation: 270
          }
        ]
      };
    },
    gaugeChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '75%',
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        }
      };
    }
  },
  methods: {
    getColorForValue(value) {
      const { danger, warning, success } = this.thresholds;
      
      if (value <= danger) {
        return '#dc3545'; // danger/red
      } else if (value <= warning) {
        return '#ffc107'; // warning/yellow
      } else {
        return '#28a745'; // success/green
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 200px;
  width: 100%;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.chart-title {
  font-size: 1.1rem;
  margin-bottom: 10px;
}

.gauge-wrapper {
  position: relative;
  height: 150px;
}

.gauge-center {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.gauge-value {
  font-size: 1.5rem;
  font-weight: bold;
}

.gauge-label {
  font-size: 0.8rem;
  color: #6c757d;
}
</style>
